import jApi from './jApi';

export default {
  // Data Mitra -----------------------------------
  getListMitra(req) {
    const api = jApi.generateApi();
    return api.post('hubin/mitra/list', req)
      .then(res => res);
  },

  createMitra(req) {
    const api = jApi.generateApi();
    return api.post('hubin/mitra/create', req)
      .then(res => res);
  },

  updateMitra(req) {
    const api = jApi.generateApi();
    return api.post('hubin/mitra/update', req)
      .then(res => res);
  },

  deleteMitra(req) {
    const api = jApi.generateApi();
    return api.post('hubin/mitra/delete', req)
      .then(res => res);
  },

  exportMitra(req) {
    const api = jApi.generateApi();
    return api.post('hubin/mitra/exportXLS', req)
      .then(res => res);
  },

  // Data Pengumuman -----------------------------------
  getListPengumuman(req) {
    const api = jApi.generateApi();
    return api.post('hubin/pengumuman/list', req)
      .then(res => res);
  },

  getListPengumumanWidget(req) {
    const api = jApi.generateApi();
    return api.post('hubin/pengumuman/list-widget', req)
      .then(res => res);
  },

  createPengumuman(req) {
    const api = jApi.generateApi();
    return api.post('hubin/pengumuman/create', req)
      .then(res => res);
  },

  updatePengumuman(req) {
    const api = jApi.generateApi();
    return api.post('hubin/pengumuman/update', req)
      .then(res => res);
  },

  deletePengumuman(req) {
    const api = jApi.generateApi();
    return api.post('hubin/pengumuman/delete', req)
      .then(res => res);
  },

  exportPengumuman(req) {
    const api = jApi.generateApi();
    return api.post('hubin/pengumuman/exportXLS', req)
      .then(res => res);
  },

  // Data Buku Tamu -----------------------------------
  getListBukuTamu(req) {
    const api = jApi.generateApi();
    return api.post('hubin/buku-tamu/list', req)
      .then(res => res);
  },

  createBukuTamu(req) {
    const api = jApi.generateApi();
    return api.post('hubin/buku-tamu/create', req)
      .then(res => res);
  },

  updateBukuTamu(req) {
    const api = jApi.generateApi();
    return api.post('hubin/buku-tamu/update', req)
      .then(res => res);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiHubin.js